// @flow

import * as React from 'react';

import type { ProductId } from '@gandi/cart';
import { Base } from '@gandi/ui';

import Counter from './Counter';
import LabelContent from './LabelContent';
import Price from './Price';

type Props = {
  label: string,
  count: number,
  onChange: (count: number) => mixed,
  price?: number,
  priceCrossedOut?: number,
  detail?: React.Node,
  /** productId is used to generate a unique field id */
  productId: ProductId,
  isLoading: boolean,
  showExcludeVatMention?: boolean,
};

export default function CountRow({
  label,
  count,
  onChange,
  price,
  priceCrossedOut,
  detail,
  productId,
  isLoading,
  showExcludeVatMention = false,
}: Props): React.MixedElement {
  const inputId = `count-${productId}`;
  // TODO: Implement new style
  return (
    <Base flex gap="small" flexAlignItemsCenter>
      <div>
        <LabelContent label={label} htmlFor={inputId}>
          <Counter
            id={inputId}
            count={count}
            onChange={onChange}
            isLoading={isLoading}
          />
        </LabelContent>
        {!!detail && (
          <Base marginTop="xxsmall" size="small" color="light">
            {detail}
          </Base>
        )}
      </div>
      <Price
        price={price}
        priceCrossedOut={priceCrossedOut}
        showExcludeVatMention={showExcludeVatMention}
        tagName="span"
        flexExpandLeft
      />
    </Base>
  );
}
